import NavBar from "./components/NavBar";
import Home from "./components/Home";
import About from "./components/About";
import SocialLinks from "./components/SocialLinks";
import Project from "./components/Project";
import Exper from "./components/Exper";
import Contact from "./components/Contact";

function App() {
  return(
<>
<NavBar/>
<Home/>
<About/>
<Project/>
<Exper/>
<Contact/>


<SocialLinks/>
</> 
  );
}

export default App;
